import { keyframes } from 'styled-components';
import styledWithTheme from 'foundations-theming/utils';

const shimmerAnimation = keyframes`
  0% {
    left: -50%;
  }
  100% {
    left: 100%;
  }
`;

export const ACSkeletonBox = styledWithTheme.div<{
  shimmercolor?: string;
  backgroundcolor?: string;
  animated?: boolean;
}>`
  overflow: hidden;
  position: relative;
  background-color: ${(props) =>
    props.backgroundcolor ||
    props.theme.color['fill-accent-neutral-subtle-alt']};

  &::after {
    content: '';
    display: ${(props) => (props.animated ? 'block' : 'none')};
    position: absolute;
    width: 50%;
    height: 100%;
    top: 0;
    left: -50%;
    animation: ${shimmerAnimation} 1s cubic-bezier(0.42, 0, 0.58, 1) infinite;
    background: linear-gradient(
      to right,
      transparent 0%,
      ${(props) => props.shimmercolor || 'rgba(255, 255, 255, 0.65)'} 50%,
      transparent 100%
    );
  }
`;

export default ACSkeletonBox;
